const Body = ({ children}) => {
    return (
        <div className="main-list__table-wrapper" id="listScrollbar" data-scrollbar="true" tabIndex={"-1"}>
            <div className="scroll-content">
            <table className="main-list__table">
                {children}
            </table>
            </div>
        </div>
    );
};

export default Body;
